import { Education } from '../types/education';

export const educationData: Education[] = [
  {
    id: "saxion",
    year: "2019 - 2022",
    institution: "Saxion University of Applied Sciences",
    degree: "Bachelor of Science",
    specialty: "Creative Media Game Technologies"
  },
  {
    id: "uca",
    year: "2016 - 2018", 
    institution: "University of Creative Arts",
    degree: "Level 3 BTEC Extended Diploma",
    specialty: "Creative Media Production and Technologies"
  }
];
